<script setup>
import AppointmentForm from '@frontJs/components/forms/projectManagement/apikom/AppointmentForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenants, users, meansOfCommunications, tenant, tenantAppointment } =
    defineProps({
        tenants: {
            type: Array,
            required: true,
        },
        users: {
            type: Array,
            required: true,
        },
        meansOfCommunications: {
            type: Array,
            required: true,
        },
        tenant: {
            type: Object,
            required: false,
        },
        tenantAppointment: {
            type: [Object, null],
            required: false,
        },
    });

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="tenant && tenantAppointment">
            Mettre à jour le rendez-vous #{{ tenantAppointment.id }} - Apikom -
            Gestion de projet - Datakepler
        </title>

        <title v-else-if="tenant && !tenantAppointment">
            Créer un rendez-vous - Apikom - Gestion de projet - Datakepler
        </title>

        <title v-else-if="tenantAppointment">
            Mettre à jour le rendez-vous #{{ tenantAppointment.id }} - Apikom -
            Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un rendez-vous - Apikom - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="tenant && tenantAppointment" :tenant-name="tenant.name">
        Gestion de projet - Apikom - Mettre à jour le rendez-vous #{{
            tenantAppointment.id
        }}
    </PageTitle>

    <PageTitle
        v-else-if="tenant && !tenantAppointment"
        :tenant-name="tenant.name"
    >
        Gestion de projet - Apikom - Créer un rendez-vous
    </PageTitle>

    <PageTitle v-else-if="tenantAppointment">
        Gestion de projet - Apikom - Mettre à jour le rendez-vous #{{
            tenantAppointment.id
        }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Apikom - Créer un rendez-vous
    </PageTitle>

    <AppointmentForm
        :tenants="tenants"
        :users="users"
        :means-of-communications="meansOfCommunications"
        :tenant="tenant"
        :tenant-appointment="tenantAppointment"
    />
</template>
